/** Custom slugs are optional; the stable profile ID keeps every author reachable. */
export function getAuthorProfileHref(authorId: string, authorSlug?: string | null) {
    return `/${authorSlug || authorId}`;
}
